<template>
  <div>
    <div v-if="!loading">
      <div ref="test" class="row" style="margin: 0px">
        <div v-if="!isMobile()" class="col" style="overflow-y:scroll; max-height: 900px; max-width: 400px; border: 1px solid grey;">
          <div class="vehicle-item" @click="toggle_div(veh, veh.name,'detailsVisible')" v-for="(veh,idx) in items" style="font-size: 16px; text-align: left; padding:5px;">
            <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span>
            <span style="float:right;">
            <span v-if="veh.speedMilesPerHour == 0">
              <svg width="20" height="20" viewBox="-5 -5 15 15"><path d="M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0"  fill="darkred" stroke="white" stroke-width="1"/></svg>
            </span>
            <span v-else-if="veh.headingDegrees > 0">
              <svg width="15" height="15" viewBox="-6 4 10 6" :style="'transform: rotate(' + veh.headingDegrees + 'deg)'"><path d="M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14"  fill="#29C68A" stroke="white" stroke-width="1"/></svg>
            </span>
          </span>
            <span v-if="veh.lastLocation" style="font-size: 14px; font-weight: bold"><br/><img style="margin: 0px 5px 3px 0px" src="/location-icon.png"/>{{veh.lastLocation}}</span>
            <span v-if="veh.driver" style="font-size: 14px">
            <br/><img style="margin: 0px 5px 5px 0px" width="15px" src="/driver-icon.png"/><b>{{veh.driver.name}} {{veh.driver.phone | prettyPhoneNumber}}</b>
          </span>
            <span v-if="veh.vehicle_status" style="font-size: 14px; font-weight: bold"><br/>Status: {{veh.vehicle_status}}</span>
            <span v-if="veh.maintenance_status && veh.maintenance_status != 'null'" style="font-size: 14px; font-weight: bold">&nbsp;|&nbsp; {{veh.maintenance_status}}</span>
            <span v-if="veh.last_returned_dt" style="font-size: 14px;font-weight: bold"><br/>Returned: {{veh.last_returned_dt}}</span>
            <span v-if="veh.next_mvmt_time" style="font-size: 14px;font-weight: bold"><br/>Next: {{veh.next_mvmt_time}}</span>
            <span v-if="veh.next_mvmt_delta" style="font-size: 14px;font-weight: bold"><br/>Departs: {{veh.next_mvmt_delta}}</span>
            <div v-if="veh.curr_mvmt_route" style="font-size: 14px; font-weight: bold">
              <img width="15px" style="margin: 0px 5px 5px 0px" src="/route-icon.png"/><b>{{veh.curr_mvmt_route}}</b>
            </div>
            <hr/>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
            <GmapMarker
                v-for="(marker,idx) in markers"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :clickable="true"
                :icon="marker.icon"
                @mouseover="openInfoWindowTemplate(marker.title)"
                @mouseout="infoWindow.open=false"
            />
            <GmapInfoWindow
                :options="{
                              pixelOffset: { width: 0, height: -65 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </GmapInfoWindow>

          </GmapMap>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {get_vehicle_map_driver} from '../networking/apis'

export default {
  name: 'vehicle_map_driver',
  components: {
  },
  metaInfo: {
    title: "Fleet Integrations",
    titleTemplate: "Fleet Integrations",
  },
  data() {
    return {
      items: [],
      summary: {},
      loading: true,
      center: null,
      zoom: null,
      markers: [],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      },
      mapStyle: {
        styles: [
          {
            "featureType": "landscape",
            "stylers": [
              { "color": "#F3F4F9" }
            ]
          },          {
            "featureType": "water",
            "stylers": [
              { "color": "#C1CDE4" }
            ]
          },
          {
            "featureType": "landscape.natural.terrain",
            "stylers": [
              { "color": "#E0EDCA" }
            ]
          },
          {
            featureType: 'road',
            elementType: 'geometry.stroke',
            stylers: [{color: '#DDDDDD'}]
          },
          {
            featureType: 'road',
            elementType: 'geometry.fill',
            stylers: [{color: '#FFFFFF'}]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [{color: '#FEF8D6'}]
          },
          {
            featureType: 'transit',
            stylers: [{"visibility": "off"}]
          },
          {
            featureType: 'poi',
            stylers: [{"visibility": "off"}]
          },
        ]
      }
    }
  },
  async created() {
    this.load_data()
  },
  methods: {
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    openInfoWindowTemplate(selected_name) {
      const loc = this.items.filter(item => item.name == selected_name)[0]

      if (loc != null) {
        const position = {
          lat: Number(loc.gps.latitude),
          lng: Number(loc.gps.longitude),
        };
        this.infoWindow.position = position
        this.infoWindow.template = loc.marker_html
        this.infoWindow.open = true
      }
    },
    async load_data() {
      this.loading = true
      try {
        let vehicle_id = ''
        if (this.$route.query.vehicle_id)
          vehicle_id = this.$route.query.vehicle_id

        let samsara_vehicle_id = ''
        if (this.$route.query.samsara_vehicle_id)
          samsara_vehicle_id = this.$route.query.samsara_vehicle_id

        let booking_id = ''
        if (this.$route.query.booking_id)
          booking_id = this.$route.query.booking_id

        const {value: { data = [] } } = await get_vehicle_map_driver(this.$route.query.tenant_id,vehicle_id,samsara_vehicle_id, booking_id)
        this.summary = data.summary
        this.items = data.results
        this.zoom = this.summary.zoom

        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            const position = {
              lat: Number(loc.gps.latitude),
              lng: Number(loc.gps.longitude),
            };
            if (this.center == null) {
              this.center = position;
            }

            this.markers.push({position: position, title: loc.name, label: {text: loc.name, className: 'marker-label'}, icon: this.arrowSymbol(loc)});
          }
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    arrowSymbol(loc) {
      return {
        path: (loc.gps.speedMilesPerHour == 0 || loc.gps.headingDegrees == 0) ? "M-5,0a5,5 0 1,0 10,0a5,5 0 1,0 -10,0" : "M0,0 L-6,14 L0,0 L6,14 L0,10 L-6,14",
        scale: 1.5,
        strokeColor: "white",
        strokeStyle: "bold",
        fillColor: "#29C68A",
        fillOpacity: 1,
        rotation: Number(loc.gps.headingDegrees)
      }
    },
    pinSymbol(color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 1.5,
      }
    },
  },
  computed:{
  },
  watch: {
  }
}
</script>
<style>
.marker-label {
  opacity: 0.8;
  bottom: 40px;
  position: relative;
  border: 1px solid black;
  background-color: #999;
  color: white !important;
  border-radius: 4px;
  padding: 2px;
}

</style>